import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {isEmpty} from 'lodash/lang';
import {ListGroup, ListGroupItem} from 'react-bootstrap';
import {withKluwellTableWrapper} from '../common';
import MessageDetailDialog from './MessageDetailDialog';
import {markMessageAsRead} from 'api/messages';
import {buildUserFullName, formatDatetime, formatRole, levelMap, getStateMap, countryMap} from 'utils/common';
import {NotificationContext} from 'contexts/notifications';

const MessageInfoItem = ({label, content}) => (
  <span className="message-info-item" style={{alignItems: 'flex-start'}}>
    <span className="prefix" style={{whiteSpace: 'nowrap'}}>
      {label}
    </span>{' '}
    {content}
  </span>
);

const buildMessageRecords = (messages) => {
  const sortedIds = messages.sortedIds || [];
  return isEmpty(sortedIds) ? [] : sortedIds.map((messageId) => messages[messageId]);
};

class MessageBoard extends React.Component {
  static contextType = NotificationContext;
  static propTypes = {
    recordPages: PropTypes.object.isRequired,
    me: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      selectedMessage: null,
    };
    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.renderMessageInfo = this.renderMessageInfo.bind(this);
  }

  openDialog(message) {
    const {me, refreshTable} = this.props;
    if (message.readAt === null && message.userId === me.id) {
      const {increaseNotificationCount} = this.context;
      markMessageAsRead(message.id).then(() => {
        refreshTable();
        increaseNotificationCount(-1);
      });
    }
    this.setState({
      selectedMessage: message,
    });
  }

  closeDialog() {
    this.setState({
      selectedMessage: null,
    });
  }

  renderMessageInfo(message) {
    const {me} = this.props;
    const {sender, receiver, timeCreated, level, state, country, receiverSchool, receiverRole, receivers} = message;
    const sentByMe = me.id === sender.id;
    return (
      <div className="message-info">
        <MessageInfoItem label="Sent At" content={formatDatetime(timeCreated / 1000, false)} />
        {!sentByMe ? (
          <MessageInfoItem label="Sent By" content={buildUserFullName(sender)} />
        ) : receiver ? (
          <MessageInfoItem label="Sent To" content={buildUserFullName(receiver)} />
        ) : receivers ? (
          <MessageInfoItem
            label="Sent To"
            content={receivers.map((receiver) => buildUserFullName(receiver)).join(',\n')}
          />
        ) : (
          <React.Fragment>
            {!isEmpty(receiverSchool) && <MessageInfoItem label="Receivers' School" content={receiverSchool.name} />}
            <MessageInfoItem label="Receivers' Role" content={formatRole(receiverRole)} />
          </React.Fragment>
        )}
        {level && <MessageInfoItem label="App Level" content={levelMap[level]} />}
        {state && <MessageInfoItem label="State" content={getStateMap(country)[state]} />}
        {country && <MessageInfoItem label="Country" content={countryMap[country]} />}
      </div>
    );
  }

  render() {
    const {selectedMessage} = this.state;
    const {recordPages} = this.props;
    const messages = recordPages[recordPages.currentPage] || {};
    const records = buildMessageRecords(messages);
    return (
      <React.Fragment>
        {!isEmpty(selectedMessage) && <MessageDetailDialog open onClose={this.closeDialog} message={selectedMessage} />}
        <div className="message-board">
          <ListGroup>
            {isEmpty(records)
              ? 'No Data'
              : records.map((message) => {
                  console.log(message);
                  console.log(message.body);
                  return (
                    <ListGroupItem
                      key={message.timeCreated}
                      onClick={() => this.openDialog(message)}
                      style={{backgroundColor: message.readAt === null ? '#e3f2fd' : 'transparent'}}
                    >
                      <div className="message-body">
                        {message.body.length > 200 ? `${message.body.slice(0, 200)}...` : message.body}
                      </div>
                      {this.renderMessageInfo(message)}
                    </ListGroupItem>
                  );
                })}
          </ListGroup>
        </div>
      </React.Fragment>
    );
  }
}

export default withKluwellTableWrapper(MessageBoard);
